import CountryLanding from "@/components/country/CountryLanding";
import { PARAGUAY } from "@/data/countryPages";

export default function EOSParaguay() {
  return <CountryLanding country={PARAGUAY} />;
}
